import request from '@/services/interceptor.js'

export const get_mezzi = (filtri) => {
    return request({
        url: '/mezzo',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_mezzo = (id) => {
    return request({
        url: `/mezzo/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const get_mezzo_kpi = () => {
    return request({
        url: '/mezzo/kpi',
        method: 'get',
        loadingBar: true
    })
}

export const get_mezzo_by_qr = (publicCode) => {
    return request({
        url: `/mezzo/qr/${publicCode}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_mezzo = (par) => {
    return request({
        url: '/mezzo',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_mezzo = (id, par) => {
    return request({
        url: `/mezzo/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_mezzo = (id) => {
    return request({
        url: `/mezzo/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_mezzo = (id, conferma) => {
    return request({
        url: `/mezzo/${id}`,
        method: 'delete',
        params: { conferma: !!conferma },
        loadingBar: true
    })
}
